(function () {
  document.documentElement.classList.remove('no-js');

  function addSampleAndCheckout(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      var target = document.querySelector('#sample');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart-add-failed');
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        window.location.href = '/cart';
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sample-checkout]');
    if (!button) return;
    event.preventDefault();
    addSampleAndCheckout(button);
  });
})();
